module.exports = __webpack_public_path__ + "media/images/logo-fc-331d6f7a63b997be1e8698e2fe7e6b5f.png";